export const resolveInitialSortKey = params => {
  const {
    config,
    sort,
    selectedFilters = {},
    hasConflictingFilters = false,
    isConflictingFilterActive = false,
  } = params || {};

  const { relevanceKey, relevanceFilter, defaultKey } = config?.search?.sortConfig || {};
  const isRelevanceOptionActive = Object.keys(selectedFilters || {}).includes(relevanceFilter);
  const hasRelevanceValue =
    isRelevanceOptionActive && selectedFilters[relevanceFilter]?.length > 0 ? relevanceKey : null;

  if (hasConflictingFilters && isConflictingFilterActive) {
    return relevanceKey;
  }

  if (sort) {
    return sort;
  }

  if (hasRelevanceValue) {
    return relevanceKey;
  }

  return defaultKey || 'createdAt';
};
